export default {
    new_account_required_message: 'Ze względu na wdrożenie nowego systemu do rezerwacji, prosimy o założenie nowego konta.<br/>Konto założone przed 07.04.2025 nie będzie działać w nowej wersji systemu.',
    new_account_required_message_2: 'UWAGA: Jeśli chcesz, możesz również dokonać rezerwacji przejazdu bez zakładania konta.',
    new_account_required_confirmation: 'Rozumiem, nie pokazuj ponownie',
    general_error: 'Wystąpił błąd, spróbuj ponownie później',
    followme_title: 'Follow me!',
    lang_pl: 'PL',
    lang_en: 'EN',
    lang_de: 'DE',
    date: 'Data',
    loading: 'Ładowanie',
    send: 'Wyślij',
    baggage_hand: 'Bagaż podręczny do 5 kg',
    baggage_register: 'Bagaż rejestrowany do 25 kg',
    book_and_payment: 'Zarezerwuj i zapłać',
    book: 'Zarezerwuj',
    delete: 'Usuń',
    back: 'Wstecz',
    next: 'Dalej',
    yes: 'Tak',
    no: 'Nie',
    select: 'Wybierz',
    net: 'netto',
    gross: 'brutto',
    piece: 'szt.',
    vehicle: 'Pojazd',
    cancel: 'Anuluj',
    ok: 'OK',
    email_example: 'np. email@strona.com',
    departure: 'Wyjazd',
    return: 'Powrót',
    departure_date: 'Data wyjazdu',
    departure_time: 'Godzina wyjazdu',
    return_date: 'Data powrotu',
    return_time: 'Godzina powrotu',
    date_pick: 'Wybierz datę',
    from: 'Z',
    to: 'Do',
    passenger: 'Pasażer',
    passengers: 'Pasażerowie',
    passengers_amount: 'Liczba pasażerów',
    adults: 'Dorośli',
    kids: 'Dzieci',
    child_age_3: 'Dzieci do lat 3',
    purchaser_details: 'Dane kontaktowe osoby zamawiającej',
    invoice: 'Faktura',
    payment_method: 'Metoda płatności',
    order_error: 'Błąd przy składaniu zamówienia',
    home_title: 'Rezerwacja online przejazdów Follow me!',

    first_name: 'Imię',
    last_name: 'Nazwisko',
    email: 'Email',
    phone_number: 'Nr telefonu',
    street: 'Ulica',
    building_number: 'Numer budynku',
    apartment_number: 'Numer lokalu',
    airport: 'Lotnisko',
    zip: 'Kod pocztowy',
    flight_number: 'Numer lotu',
    comment: 'Uwagi',
    vat_number: 'NIP',
    address: 'Adres',
    post_code: 'Kod pocztowy',
    city: 'Miasto',
    country: 'Kraj',
    company_name: 'Nazwa firmy',
    age: 'Wiek',

    price: 'Cena',
    total: 'Razem',

    admin_panel: 'Panel administratora',

    no_transfers_found: 'Nie znaleziono przejazdów',

    no_transfers_found_ask_by_email:
        'Jeżeli nie widzisz dostępnego połączenia w wybranym terminie, zapytaj o dostępność miejsc poprzez e-mail <a href="mailto:{email}">{email}</a>.',

    at_ber_outdated_travel:
        'Od 28 kwietnia 2022 przejazdy na lotnisko BER (Berlin-Brandenburg) oraz z lotniska BER (Berlin-Brandenburg) są realizowane pod marką Flixbus (autokary i kierowcy Follow me!). Rezerwacji możesz dokonać na stronie <a href="https://flixbus.pl/" target="_blank">flixbus.pl</a>.',

    at_ber_outdated_travel_2:
        'Jeżeli pod powyższym adresem nie odnajdziesz dogodnego połączenia, to zapraszamy do skorzystania z przejazdu współdzielonego (ridesharing) realizowanego w opcji door to door.',

    field_is_required: 'Pole {field} jest wymagane',

    datetime_has_to_be_in_the_future: 'Pole {field} musi być w przyszłości',
    datetime_has_to_be_in_2_days_from_now:
        'Zbyt krótki czas do odjazdu – rezerwacja możliwa minimum 48 godzin przed rozpoczęciem przejazdu',
    time_has_to_be_later_than:
        'Pole {field} musi być godziną późniejszą niż {field_parent}',
    time_invalid: 'Pole {field} jest niekompletne.',
    phone_has_to_start_with_plus:
        'Numer telefonu musi zawierać numer kierunkowy zaczynający się znakiem +',

    data_updated_success: 'Dane zostały pomyślnie zaktualizowane',

    maintenance_long_wait_info:
        'Czas realizacji zamówienia się wydłuża?<br />Przejdź do zakupu biletu na stronę <a href="https://www.interglobus.pl/Default.aspx?language=pl">interglobus.pl</a>',

    user_data: {
        header: 'Moje dane',
        name: 'Imię i Nazwisko',
        phone: 'Numer telefonu',
        submit: 'Zapisz',
    },

    auth: {
        session_expired: 'Sesja wygasła, aby kontynuować zaloguj się ponownie.',
        activate_account_here: 'Aktywuj swoje konto tutaj:',
        activate_account_here_link: 'Aktywacja',
        required_fields_info: 'Pola wymagane',
        confirm_registration: 'Potwierdź rejestrację konta',
        activation_code: 'Kod aktywacyjny',
        confirm: 'Potwierdź',
        confirm_resend: 'Nie otrzymałeś kodu?',
        confirm_resend_submit: 'Wyślij kod ponownie',
        confirm_success: 'Konto zostało aktywowane, możesz się teraz zalogować.',
        confirm_resend_back: 'Powrót',
        confirm_resend_success: 'Wysłano kod ponownie, sprawdź skrzynkę odbiorczą.',
        login_failed: 'Nieprawidłowy adres e-mail lub hasło.',
        login_success: 'Zalogowano pomyślnie',
        register_success: 'Zarejestrowano pomyślnie. Potwierdź rejestrację klikając w link w wiadomości wysłanej na podany adres e-mail.',
        reset_password_success: 'Link do zresetowania hasła został wysłany na podany adres e-mail.',
        first_name: 'Imię',
        last_name: 'Nazwisko',
        login_header: 'Zaloguj się',
        email: 'E-mail',
        email_address: 'Adres E-mail',
        password: 'Hasło',
        confirm_password: 'Potwierdź hasło',
        forgot_password: 'Zapomniałeś hasła?',
        password_match_warning: 'Hasła muszą być takie same',
        remember_me: 'Zapamiętaj mnie',
        submit: 'Zaloguj',
        login: 'Zaloguj',
        logout: 'Wyloguj',
        register: 'Zarejestruj',
        reset_password: {
            header: 'Zresetuj hasło',
            send_link_submit: 'Wyślij link',
            submit: 'Zmień',
            password_changed: 'Hasło zostało zmienione',
        },
        username: 'Nazwa użytkownika',
        personal_register: 'Konto osobiste',
        business_register: 'Konto firmowe',
        activation_warning:
            'Konto będzie aktywne po zatwierdzeniu przez administratora',
        profile: {
            invoice_info: 'Dane do faktury',
            company_name: 'Nazwa firmy',
            address: 'Adres',
            tax_number: 'NIP',
            phone: 'Numer telefonu',
            post_code: 'Kod pocztowy',
            city: 'Miasto',
            country: 'Państwo',
        },
        countries: {
            POLAND: 'Polska',
            AUSTRIA: 'Austria',
            BELGIUM: 'Belgia',
            BULGARIA: 'Bułgaria',
            CROATIA: 'Chorwacja',
            REPUBLIC_OF_CYPRUS: 'Republika Cypryjska',
            CZECH_REPUBLIC: 'Czechy',
            DENMARK: 'Dania',
            ESTONIA: 'Estonia',
            FINLAND: 'Finlandia',
            FRANCE: 'Francja',
            GERMANY: 'Niemcy',
            GREECE: 'Grecja',
            HUNGARY: 'Węgry',
            IRELAND: 'Irlandia',
            ITALY: 'Włochy',
            LATVIA: 'Łotwa',
            LITHUANIA: 'Litwa',
            LUXEMBOURG: 'Luksemburg',
            MALTA: 'Malta',
            NETHERLANDS: 'Holandia',
            PORTUGAL: 'Portugalia',
            ROMANIA: 'Rumunia',
            SLOVAKIA: 'Słowacja',
            SLOVENIA: 'Słowenia',
            SPAIN: 'Hiszpania',
            SWEDEN: 'Szwecja',
        },
    },

    offer_types: {
        airport_transfers: 'Szczecin - Goleniów ✈️ - Szczecin',
        airport_transfers_card_title: 'Szczecin - Goleniów',
        business_taxi: 'Business Taxi',
        family_airport_taxi: 'Smart Taxi',
        coaches: 'Wynajem Autokarów',
        business_travel_management: 'Business Travel Management',
        bus_rental: 'Wynajem Busów (bez kierowcy)',
        tours: 'Wycieczki',
        berbus: 'BERBUS Szczecin - Berlin ✈️ - Szczecin',
        berbus_card_title: 'Szczecin - Berlin',
    },

    components: {
        phone_input: {
            format_hint: 'Format: +48500500500',
        },

        taxi_search_form: {
            from: 'Z',
            to: 'Do',
            search_no_results: 'Wybierz lotnisko lub wpisz adres, rozpoczynając od nazwy ulicy.',
            search_no_results2: 'Jeśli masz problem z odnalezieniem, skontaktuj się z nami: <a href="mailto:{email}">{email}</a>.',
            date_pick: 'Wybierz datę',
            submit: 'Szukaj',
            add_time: 'Dodaj godzinę',

            departure_date: 'Data wyjazdu',
            departure_time: 'Godzina wyjazdu',
        },

        passengers: {
            quantity: 'nikt | 1 osoba | {count} osoby  | {count} osób',
            quantity_adults:
                'none | 1 os. dorosła | {count} os. dorosłe | {count} os. dorosłych',
            quantity_children: 'Bez dzieci | 1 dziecko | {count} dzieci',
            quantity_label: 'Ilość osób',
            quantity_label_adults: 'Ilość dorosłych',
            quantity_label_children: 'Ilość dzieci',
            quantity_label_children_max_3: 'Ilość dzieci do lat 3',
        },
        coach_search_form: {
            from: 'Wyjazd z',
            to: 'Przyjazd do',
            search_no_results:
                'Podaj nazwę miejscowości, jeśli nie zostanie znaleziona skontaktuj się z nami.',
            date_pick: 'Podaj datę',
            time_pick: 'Podaj godzinę',
            departure_date: 'Data wyjazdu',
            departure_time: 'Godzina wyjazdu',
            return_date: 'Data powrotu',
            return_time: 'Godzina powrotu',
            submit: 'Dalej',
            word_from: 'z',
            progress_bar: {
                step1: 'Informacje podstawowe',
                step2: 'Typ przejazdu',
                step3: 'Dodatkowe opcje',
                step4: 'Formularz kontaktowy',
                step5: 'Podsumowanie',
            },
        },
    },

    taxi: {
        return_datetime: 'Data i godzina powrotu',
        return_date: 'Data powrotu',
        return_time: 'Godzina powrotu',
        provide_flight_time: 'Proszę podać godzinę wylotu',
        provide_flight_arrival_time: 'Proszę podać godzinę przylotu',

        validation: {
            return_date_required: 'Data powrotu jest wymagana',
            return_time_required: 'Godzina powrotu jest wymagana',
            at_least_one_passenger_required:
                'Proszę wybrać przynajmniej jednego pasażera',
            return_time_after_departure_time:
                'Data i godzina powrotu musi być późniejsza',
        },

        components: {
            cart: {
                header: 'Twoja podróż',

                no_travel: 'Wybierz pojazd, aby dodać go do podróży.',
                departure: 'Wyjazd',
                return: 'Powrót',

                base_price: 'Cena podstawowa',
                discount_value: 'Wartość rabatu',
                user_discount_value: 'Rabat użytkownika',
            },

            progress: {
                search: 'Wyszukiwanie',
                journey_select: 'Wybór przejazdu',
                passengers_data: 'Dane pasażerów',
                addresses: 'Adresy',
                additional_options: 'Opcje dodatkowe',
                summary_and_payment: 'Podsumowanie i płatność',
            },
        },


        pages: {
            vehicles: {
                no_transfers_found: 'Nie znaleziono połączeń',
                short_time:
                    'Do realizacji Twojego przejazdu zostało mniej niż 48 godzin. <br />  \n' +
                    'Jeżeli dokonujesz rezerwacji w godzinach pracy biura (pon–pt 8:00 – 18:00, sob-nd 10:00 – 18:00), zweryfikujemy dostępność pojazdu i w ciągu kilku godzin potwierdzimy Twoją rezerwację.  <br /> \n' +
                    'Jeżeli dokonujesz rezerwacji poza godzinami pracy biura, Twoja rezerwacja zostanie zweryfikowana kolejnego dnia.  ',

                short_time_st:
                    'Do realizacji Twojego przejazdu zostało mniej niż 36 godzin. <br /> \n' +
                    'Jeżeli dokonujesz rezerwacji w godzinach pracy biura (pon–pt 8:00 – 18:00, sob-nd 10:00 – 18:00), zweryfikujemy dostępność pojazdu i w ciągu kilku godzin potwierdzimy Twoją rezerwację. <br /> \n' +
                    'Jeżeli dokonujesz rezerwacji poza godzinami pracy biura, Twoja rezerwacja zostanie zweryfikowana kolejnego dnia. ',

                short_time_bt:
                    'Do realizacji Twojego przejazdu zostało mniej niż 36 godzin. <br /> \n' +
                    'Jeżeli dokonujesz rezerwacji w godzinach pracy biura (pon–pt 8:00 – 18:00, sob-nd 10:00 – 18:00), zweryfikujemy dostępność pojazdu i w ciągu kilku godzin potwierdzimy Twoją rezerwację. <br /> \n' +
                    'Jeżeli dokonujesz rezerwacji poza godzinami pracy biura, Twoja rezerwacja zostanie zweryfikowana kolejnego dnia. ',

                eco_vehicle_confirmation:
                    '<p>Wybrałeś opcję ECO {offerType}, do Twojego przejazdu zostanie dopasowany pasażer, dzięki czemu będziesz mógł skorzystać z najatrakcyjniejszej cenowo oferty {offerType}.</p>' +
                    '<p>Ważne!<br />W sytuacji, gdy nie będzie możliwe połączenie Twojego przejazdu z innym pasażerem, będziesz mógł skorzystać z przejazdu w cenie regularnej {offerType} (za dopłatą) lub zrezygnować z przejazdu bez żadnych kosztów. Wszelkie informacje otrzymasz od nas w kolejnym mailu.</p>',
                price_includes: 'W cenie',
                prefer_info:
                    'Informujemy, że w przypadku braku dostępności wybranej marki samochodu, usługę zrealizujemy innym, tej samej klasy autem.',
            },
            addresses: {
                header: 'Adresy',

                pickup_addresses: 'Adres odbioru',
                destination_addresses: 'Adres docelowy',

                return_travel: 'Powrót',

                return_pickup_addresses: 'Powrót: Adres odbioru',
                return_destination_addresses: 'Powrót: Adres docelowy',

                address_add: 'Dodaj kolejny adres',
                address_remove_confirm: 'Czy na pewno chcesz usunąć ten adres?',
                book_return: 'Chcę zarezerwować przejazd powrotny',

                submit: 'Przejdź do opcji dodatkowych',

                return_not_possible:
                    'Nasz cennik nie zawiera kursu powrotnego dla tego przejazdu, skontaktuj się z nami jeśli chcesz zamówić podróż powrotną: <a href="mailto:{email}">{email}</a>',

                pickup_address_info_title: 'Dodaj kolejny adres',
                pickup_address_info_desc:
                    '<p>Jeżeli chcesz dodać trzeci adres odbioru, wpisz go w polu Uwagi do adresu (powyżej). Koszt dodatkowego miejsca odbioru to 9 zł brutto.</p><p>Jest to opcja niestandardowa, dlatego wspomniany koszt nie zostanie uwzględniony podczas płatności za to zamówienie. Należność należy uregulować osobno, na podstawie instrukcji przesłanych mailowo przez Biuro Obsługi Klienta Follow me!</p>',
            },

            passengers: {
                login_in_to_speed_up_process:
                    'Masz konto? Zaloguj się, aby przyśpieszyć proces zakupu.',
                passengers_data: 'Dane pasażerów',
                go_to_addresses: 'Przejdź do adresów',
                add_next_passenger_data: 'Dodaj dane kolejnego pasażera',
            },

            options: {
                header: 'Opcje dodatkowe',

                comments: 'Komentarz do opcji dodatkowych (opcjonalny)',

                submit: 'Przejdź do podsumowania',
            },

            summary: {
                header: 'Podsumowanie i płatność',

                email_tooltip:
                    'Na podany adres email wyślemy Ci potwierdzenie zakupu oraz bilety.',
                phone_number_tooltip:
                    'Numer telefonu wykorzystywany tylko w sytuacjach awaryjnych.',

                is_invoice: 'Potrzebuję fakturę',

                invoice: {
                    name: 'Nazwa',
                },

                tos: 'Dokonując zakupu akceptuję {general} oraz {privacy}.',
                tos_general: 'ogólne warunki przewozu Follow Me!',
                tos_privacy: 'politykę prywatności',

                consents_text:
                    'Rezerwację uważa się za dokonaną po jej opłaceniu i otrzymaniu potwierdzenia na adres e-mail. W przypadku braku potwierdzenia prosimy o kontakt.',

                submit: 'Zapłać teraz {amount}',
                submit_no_payment: 'Złóż zamówienie',

                creating_order: 'Tworzenie zamówienia',
                creating_order_redirect:
                    'Za chwilę zostaniesz przekierowany na stronę z płatnością',

                discount_codes: {
                    header: 'Kody rabatowe',
                    submit: 'Użyj',
                },

                short_time_payment:
                    'Nasz pracownik prześle potwierdzenie realizacji przejazdu z linkiem do płatności.',
                delayed_payment: 'Twoje konto zezwala na odroczoną płatność.',
                create_user_account:
                    'Stwórz konto użytkownika używając powyższych danych',

                payment_polcard:
                    '[First Data Polcard] Płatność kartą / szybki przelew',
                payment_ecard: 'Szybki przelew / płatność kartą / BLIK',
                payment_ecard_optional_info: 'metoda płatności eCard zostanie wyłączona z końcem września 2024',

                use_first_passenger_data: 'Użyj danych pierwszego pasażera',
            },

            confirmation: {
                header: 'Zamówienie #{orderNumber}',
                bt: {
                    paid:
                        '<p>Zamówienie nr {orderNumber} zostało przyjęte.</p>' +
                        '<p>Twoja rezerwacja została opłacona, szczegóły zamówienia wysłaliśmy na adres e-mail podany w rezerwacji.</p>' +
                        '<p>WAŻNE: jeżeli podróżujesz na lotnisko, upewnij się, czy zaplanowałeś podróż z odpowiednim zapasem czasowym. Pamiętaj, że bezpieczny przyjazd na lotnisko to min. 2h przed wylotem.</p>' +
                        '<p>Do zobaczenia na pokładzie Follow me!</p>',
                    paid_eco:
                        '<p>Zamówienie nr {orderNumber} zostało przyjęte.</p>' +
                        '<p>Wybrałeś opcję ECO Business Taxi, do Twojego przejazdu zostanie dopasowany pasażer, dzięki czemu będziesz mógł skorzystać z najatrakcyjniejszej cenowo oferty Business Taxi.</p>' +
                        '<p>Ważne!  W sytuacji, gdy nie będzie możliwe połączenie Twojego przejazdu z innym pasażerem, będziesz mógł skorzystać z przejazdu w cenie regularnej Business Taxi (za dopłatą) lub zrezygnować z przejazdu bez żadnych kosztów. Wszelkie informacje otrzymasz od nas w kolejnym mailu.</p>' +
                        '<p>Jeżeli nie otrzymasz wiadomości sprawdź zakładkę „Spam” lub skontaktuj się z naszą infolinią podając nr zamówienia.</p>',
                    short_time:
                        '<p>Zamówienie nr {orderNumber} zostało przyjęte.</p>' +
                        '<p>W związku z tym, że do realizacji Twojego przejazdu pozostało mniej niż 36h, niezbędna jest weryfikacja dostępności pojazdu.</p>' +
                        '<p>Potwierdzimy Twoją rezerwację w ciągu max 2h. Powiadomienie i dalsze instrukcje otrzymasz na adres e-mail podany w rezerwacji.</p>' +
                        '<p>Jeżeli nie otrzymasz wiadomości, sprawdź zakładkę „Spam” lub skontaktuj się z naszą infolinią podając nr zamówienia.</p>',
                    deferred:
                        '<p>Zamówienie nr {orderNumber} zostało przyjęte.</p>' +
                        '<p>Szczegóły zamówienia wysłaliśmy na adres e-mail podany w rezerwacji.</p>' +
                        '<p>WAŻNE: jeżeli podróżujesz na lotnisko, upewnij się, czy zaplanowałeś podróż z odpowiednim zapasem czasowym. Pamiętaj, że bezpieczny przyjazd na lotnisko to min. 2h przed wylotem.</p>' +
                        '<p>Do zobaczenia na pokładzie Follow me!</p>',
                },
                fat: {
                    paid:
                        '<p>Zamówienie nr {orderNumber} zostało przyjęte.</p>' +
                        '<p>Twoja rezerwacja została opłacona, szczegóły zamówienia wysłaliśmy na adres e-mail podany w rezerwacji.</p>' +
                        '<p>WAŻNE: jeżeli podróżujesz na lotnisko, upewnij się, czy zaplanowałeś podróż z odpowiednim zapasem czasowym. Pamiętaj, że bezpieczny przyjazd na lotnisko to min. 2h przed wylotem.</p>' +
                        '<p>Do zobaczenia na pokładzie Follow me!</p>',
                    paid_eco:
                        '<p>Zamówienie nr {orderNumber} zostało przyjęte.</p>' +
                        '<p>Wybrałeś opcję ECO Smart Taxi, do Twojego przejazdu zostanie dopasowany pasażer, dzięki czemu będziesz mógł skorzystać z najatrakcyjniejszej cenowo oferty Smart Taxi.</p>' +
                        '<p>Ważne!  W sytuacji, gdy nie będzie możliwe połączenie Twojego przejazdu z innym pasażerem, będziesz mógł skorzystać z przejazdu w cenie regularnej Smart Taxi (za dopłatą) lub zrezygnować z przejazdu bez żadnych kosztów. Wszelkie informacje otrzymasz od nas w kolejnym mailu.</p>' +
                        '<p>Jeżeli nie otrzymasz wiadomości sprawdź zakładkę „Spam” lub skontaktuj się z naszą infolinią podając nr zamówienia.</p>',
                    short_time:
                        '<p>Zamówienie nr {orderNumber} zostało przyjęte.</p>' +
                        '<p>W związku z tym, że do realizacji Twojego przejazdu pozostało mniej niż 48h,  niezbędna jest weryfikacja dostępności pojazdu.</p>' +
                        '<p>Potwierdzimy Twoją rezerwację w ciągu max 2h. Powiadomienie i dalsze instrukcje otrzymasz na adres e-mail podany w rezerwacji.</p>' +
                        '<p>Jeżeli nie otrzymasz wiadomości, sprawdź zakładkę „Spam” lub skontaktuj się z naszą infolinią podając nr zamówienia.</p>',
                    deferred:
                        '<p>Zamówienie nr {orderNumber} zostało przyjęte.</p>' +
                        '<p>Szczegóły zamówienia wysłaliśmy na adres e-mail podany w rezerwacji.</p>' +
                        '<p>WAŻNE: jeżeli podróżujesz na lotnisko, upewnij się, czy zaplanowałeś podróż z odpowiednim zapasem czasowym. Pamiętaj, że bezpieczny przyjazd na lotnisko to min. 2h przed wylotem.</p>' +
                        '<p>Do zobaczenia na pokładzie Follow me!</p>',
                },
                berbus: {
                    paid: `<p>Zamówienie nr <em>{orderNumber}</em> zostało przyjęte.</p>
                        <p>Twoja rezerwacja została opłacona, szczegóły zamówienia wysłaliśmy na adres e-mail podany w rezerwacji. W związku z wyborem przejazdu współdzielonego BERBUS, dokładną godzinę odbioru spod wskazanego adresu prześlemy w osobnym mailu. Informację otrzymasz maksymalnie 24h przed wybraną datą przejazdu.</p>
                        <p>WAŻNE: jeżeli podróżujesz na lotnisko, upewnij się, czy zaplanowałeś podróż z odpowiednim zapasem czasowym. Pamiętaj, że bezpieczny przyjazd na lotnisko to min. 2h przed wylotem.</p>
                        <p>Do zobaczenia na pokładzie Follow me!</p>`,
                    paid_eco: `<p>Zamówienie nr <em>{orderNumber}</em> zostało przyjęte.</p>
                        <p>Twoja rezerwacja została opłacona, szczegóły zamówienia wysłaliśmy na adres e-mail podany w rezerwacji. W związku z wyborem przejazdu współdzielonego BERBUS, dokładną godzinę odbioru spod wskazanego adresu prześlemy w osobnym mailu. Informację otrzymasz maksymalnie 24h przed wybraną datą przejazdu.</p>
                        <p>WAŻNE: jeżeli podróżujesz na lotnisko, upewnij się, czy zaplanowałeś podróż z odpowiednim zapasem czasowym. Pamiętaj, że bezpieczny przyjazd na lotnisko to min. 2h przed wylotem.</p>
                        <p>Do zobaczenia na pokładzie Follow me!</p>`,
                    short_time: `<p>Zamówienie nr <em>{orderNumber}</em> zostało przyjęte.</p>
                        <p>W związku z tym, że do realizacji Twojego przejazdu pozostało mniej niż 48h, niezbędna jest weryfikacja dostępności miejsc.</p>
                        <p>Potwierdzimy Twoją rezerwację w ciągu max 2h. Powiadomienie i dalsze instrukcje otrzymasz na adres e-mail podany w rezerwacji.</p>
                        <p>Jeżeli nie otrzymasz wiadomości, sprawdź zakładkę „Spam” lub skontaktuj się z naszą infolinią podając nr zamówienia.</p>`,
                    deferred: `<p>Zamówienie nr <em>{orderNumber}</em> zostało przyjęte.</p>
                        <p>Szczegóły zamówienia wysłaliśmy na adres e-mail podany w rezerwacji.</p>
                        <p>WAŻNE: jeżeli podróżujesz na lotnisko, upewnij się, czy zaplanowałeś podróż z odpowiednim zapasem czasowym. Pamiętaj, że bezpieczny przyjazd na lotnisko to min. 2h przed wylotem.</p>
                        <p>Do zobaczenia na pokładzie Follow me!</p>`,
                },
            },

            payment_error: {
                header: 'Odrzucona płatność.',
                details: 'Płatność została odrzucona.',
            },
        },
    },

    airport_transfers: {
        components: {
            search_form: {
                from: 'Z',
                to: 'Do',
                search_no_results:
                    'Podaj nazwę miejscowości, jeśli nie zostanie znaleziona skontaktuj się z nami: <a href="mailto:{email}">{email}</a>',
                date_pick: 'Wybierz datę',
                submit: 'Szukaj',
                one_way: 'W jedną stronę',
            },
            progress_header: {
                step1: 'Podstawowe informacje',
                step2: 'Wyjazdy',
                step3: 'Powroty',
                step4: 'Dane pasażerów',
                step5: 'Opcje dodatkowe',
                step6: 'Podsumowanie',
            },
        },
        pages: {
            lowest_price: 'Najniższa cena dnia',
            all_transfers: 'Wszystkie przejazdy',
            select: 'Wybierz',
            cart: {
                your_travel: 'Twoja podróż',
                empty_message: 'Wybierz przejazd aby dodać do swojej podróży',
            },
            pick_departure_stop: 'Wybierz przystanek',
            pick_arrival_stop: 'Wybierz przystanek',
            change_stop: 'Zmień przystanek',
            destination_airport: 'Lotnisko docelowe',

            confirmation: {
                header: 'Zamówienie zostało przyjęte',
                details: 'Szczegóły zamówienia otrzymasz na Twój adres e-mail.',
            },
            purchaser_age: 'Wiek zamawiającego',
            stop: 'Przystanek',
            options_info:
                'Wybrane opcje dodatkowe nie są wliczone w cenę biletu. Ewentualna dopłata będzie pobierana przez kierowcę przed przejazdem.',
            phone_length_error: 'Niewłaściwa długość numeru telefonu',
            zip_length_error: 'Niewłaściwa długość kodu pocztowego (minimalnie 4 znaki)',
            email_validation: 'Nieprawidłowy adres e-mail',

            addresses: {
                ticket_type: 'Rodzaj biletu',
                ticket_types: {
                    normal: 'normalny',
                    child: 'dzieci do lat 4',
                },
            },

            summary: {
                consents_text:
                    'Rezerwację uważa się za dokonaną po jej opłaceniu i otrzymaniu potwierdzenia na adres e-mail. W przypadku braku potwierdzenia prosimy o kontakt.',
            },
        },
        errors: {
            no_travels_found:
                'Nie znaleziono przejazdów dla podanych parametrów',
        },
    },

    tours: {
        header: 'Rezerwacja wycieczki',
        date_from: 'Data od',
        date_to: 'Data do',
        adults_count: 'Liczba osób dorosłych',
        person_count: 'Liczba osób',
        children_count: 'Liczba dzieci',
        email: 'Twój adres email',
        message_content: 'Twoja wiadomość',
        name: 'Imię i nazwisko',
        phone: 'Numer telefonu',
        submit: 'Wyślij',
        form_sent: 'Twoje zapytanie zostało wysłane',
    },

    berbus: {
        components: {
            search_form: {
                enter_address: 'Wpisz adres',
                search_no_results: 'Brak wyników',
            },

            cart: {
                passenger_types: {
                    adult: 'Dorośli',
                    child_age_3: 'Dzieci do lat 3',
                },
            },
            stopInfo: {
                title: 'Gdzie zatrzymuje się BERBUS?',
                p1: 'Kierowca usługi BERBUS czeka na podróżnych, którzy wylądowali na lotnisku Brandenburg w Berlinie i udają się w kierunku Szczecina, tuż przed samym wyjściem z terminala T-1 przy szklanych wiatach położonych na poziomie przylotów.',
                p2: 'Osoby, które podróżowały BERBUSem ze Szczecina informujemy, że jest to to samo miejsce, w którym wysiadali Państwo kierując się na swój lot.',
            },
        },

        pages: {
            address: {
                header: 'Potrzebne informacje',

                address_from: 'Adres z',
                address_to: 'Adres do',

                go_back: 'Wróć',
                submit: 'Przejdź do wyboru przejazdu',

                errors: {
                    invalid_search_param:
                        'Nieprawidłowy parametr wyszukiwania.',
                    invalid_passengers_adult: 'Nieprawidłowa liczba pasażerów.',
                    no_addresses: 'Nie udało się znaleźć żadnego adresu.',
                    incomplete_start_address:
                        'Uzupełnij brakujące pola adresu "z".',
                    incomplete_end_address:
                        'Uzupełnij brakujące pola adresu "do".',
                    start_zone_not_found:
                        'Brak przejazdów z podanego adresu "z".',
                    end_zone_not_found:
                        'Brak przejazdów z podanego adresu "do".',
                    geo_response_error:
                        'Wystąpił błąd podczas wyszukiwania adresu, spróbuj ponownie później.',
                },
            },

            vehicle: {
                price_per_person: '/ os.',
                description: 'Podróżuj w bardzo dobrej cenie prosto spod domu! Rozwiązanie oparte na zasadzie współdzielenia przejazdów tzw. Ridesharing, w którym łączymy osoby podróżujące w tym samym kierunku o tej samej porze. Po połaczeniu wszystkich pasażerów i na dzień przed podróżą, Follow me! podaje ostateczną godzinę odbioru spod wskazanego adresu.',
            },

            passengers: {
                flight_time: 'Godzina wylotu/przylotu',
                flight_time_from: 'Godzina wylotu z',
                flight_time_to: 'Godzina przylotu do',

                submit: 'Przejdź do opcji dodatkowych',
            },
        },
    },

    orders: {
        title: 'Moje zamówienia',
        status: 'Status',
        departure_date: 'Data wyjazdu',
        route: 'Trasa',
        return_departure_date: 'Data powrotu',
        return_route: 'Trasa powrotu',
        actions: 'Akcje',
        details: 'Szczegóły',
        no_orders: 'Nie znaleziono zamówień',
        consents: 'Zgody',
        flight: 'Lot',
        components: {
            OrderStatusBadge: {
                created: 'W weryfikacji',
                deferred_payment: 'Odroczona płatność',
                paid_auto: 'Opłacony (auto)',
                paid_manual: 'Opłacony (ręcznie)',
                completed: 'Zakończony',
                canceled_client: 'Anulowany przez klienta',
                canceled: 'Odrzucony - błąd zamówienia',
                payment_rejected: 'Odrzucone - płatność',
                to_confirm: 'Rezerwacja do potwierdzenia',
                canceled_fm: 'Odrzucony - brak realizacji Fm!',
                NOT_MERGED: 'Nie scalone',
                MERGED: 'Scalone',
                PLANNED: 'Zaplanowane',
                ACCEPTED: 'Zaakceptowane',
                IN_PROGRESS: 'W trakcie',
                COMPLETED: 'Zakończone',
                CANCELLED: 'Anulowane',
                CANCELLED_BY_CLIENT: 'Anulowane przez klienta',
                REQUEST_FOR_QUOTATION: 'Zapytanie ofertowe',
                CONFIRMATION: 'Potwierdzenie',
                REALIZATION: 'Realizacja',
                WAITING_FOR_PAYMENT: 'Oczekiwanie na płatność',
                REJECTED_NO_PAYMENT: 'Odrzucone - brak płatności',
                HISTORICAL: 'Historyczne',
            },
            PaymentStatusBadge: {
                pending: 'Oczekujący',
                paid: 'Opłacony',
                rejected: 'Odrzucony',
                error: 'Błąd',
                MISSING: 'Brak',
                IN_PROGRESS: 'W trakcie',
                PAID: 'Opłacone',
                PARTIALLY_PAID: 'Częściowo opłacone',
            },
        },
        bt: {
            title: 'Moje zamówienia Business Taxi',
            my_orders: 'Moje zamówienia BT',
        },
        fat: {
            title: 'Moje zamówienia Smart Taxi',
            my_orders: 'Moje zamówienia Smart Taxi',
        },
        berbus: {
            title: 'Moje zamówienia BERBUS',
            my_orders: 'Moje zamówienia BERBUS',
        },
        show: {
            title: 'Detale zamówienia',
            return_to_list: 'Powrót do listy zamówień',
            stops: 'Przystanki',
            id: 'ID',
            order_details: 'Szczegóły zamówienia',
            start_place: 'Skąd',
            end_place: 'Dokąd',
            return_info: 'Szczegóły powrotu',
            return_start_place: 'Powrót z',
            return_end_place: 'Powrót do',
            no_return: 'Brak zlecenia drogi powrotnej',
            purchaser_info: 'Dane Zamawiającego',
            purchaser_full_name: 'Imię i nazwisko',
            purchaser_email: 'Adres e-mail',
            purchaser_phone: 'Numer telefonu',
            comment: 'Komentarz',
            no_comment: 'Brak komentarza',
            order_values: 'Kwoty zamówienia',
            value_name: 'Nazwa wartości',
            net_value: 'Kwota netto',
            gross_value: 'Kwota brutto',
            vat_value: 'Kwota VAT',
            base_value: 'Wartość bazowa (przed rabatem)',
            discount_value: 'Wartość rabatu',
            user_discount_value: 'Wartość rabatu użytkownika',
            value: 'Wartość całkowita (po rabacie)',
            pln_value: 'Wartość w PLN',
            payment_details: 'Szczegóły płatności',
            return: 'Powrót',
            invoice: {
                info: 'Dane do faktury',
                download_invoice: 'Pobierz fakturę',
                company: 'Nazwa firmy',
                vat_number: 'NIP',
                email: 'Adres e-mail',
                address: 'Adres',
                zip: 'Kod pocztowy',
                city: 'Miasto',
                country: 'Państwo',
            },
            payments: {
                status: 'Status płatności',
                provider: 'Dostawca płatności',
                amount: 'Kwota',
                amount_pln: 'Kwota [PLN]',
                no_payments_found: 'Brak zarejestrowanych płatności',
            },
            passengers: {
                info: 'Szczegóły pasażerów',
                full_name: 'Imię i nazwisko',
                phone: 'Nr telefonu',
                no_passengers: 'Brak pasażerów',
            },
            additional_options: {
                info: 'Opcje dodatkowe',
                name: 'Opcja',
                quantity: 'Ilość',
            },
            travel_option: {
                cradle_0_13_kg: 'Kołyska (0-13 kg)',
                child_seat_9_18_kg: 'Fotelik (9-18 kg)',
                child_seat_15_25_kg: 'Fotelik (9-18 kg)',
                booster_seat_22_36_kg: 'Podstawka (22-36 kg)',
                skiing_equipment: 'Sprzęt narciarski',
                bike: 'Rower',
                stroller: 'Wózek dziecięcy',
                musical_equipment: 'Sprzęt muzyczny',
                large_suitcase_15_32_kg: 'Duża walizka (15-32 kg)',
                no_travel_options: 'Brak opcji dodatkowych',
            },
            payment_providers: {
                CASH: 'Gotówka',
                CARD: 'Karta',
                FAST_TRANSFER: 'Szybki przelew',
                TRADITIONAL_TRANSFER: 'Przelew tradycyjny',
                ADVANCE: 'Zaliczka',
                CASH_DRIVER: 'Gotówka u kierowcy',
                CARD_DRIVER: 'Karta u kierowcy',
                TRANSFER: 'Przelew',
            },
        },
    },

    coaches: {
        one_way: 'W jedną stronę?',
        first_header: 'Wypełnij formularz i sprawdź nasze ceny.',
        second_header: 'Wysłanie zapytania nie jest zobowiązujące.',

        transfer_types: {
            pick_type: 'Określ typ wyjazdu',
            additional_options: 'Wyświetl dodatkowe opcje',
            types: {
                sport: 'Wyjazd sportowy',
                school: 'Wyjazd szkolny',
                business: 'Wyjazd firmowy',
                tourist: 'Wyjazd turystyczny',
                event: 'Wyjazd okolicznościowy',
                other: 'Inny',
                other_specify: 'Opisz typ wyjazdu',
            },
        },
        additional_options: {
            title: 'Opcje dodatkowe',
            child_seats: 'Foteliki dziecięce',
            sport_equipment: 'Sprzęt sportowy',
            music_equipment: 'Sprzęt muzyczny',
            notes: 'Uwagi',
            labels: {
                quantity: 'Ilość',
                type: 'Typ',
            },
        },
        contact_data: {
            header: 'Dane kontaktowe',

            name: 'Imię i nazwisko',
            company_name: 'Nazwa firmy',
            address: 'Adres',
            post_code: 'Kod pocztowy',
            city: 'Miasto',
            country: 'Kraj',
            tax_number: 'NIP',
            phone_number: 'Telefon',
            email: 'E-mail',
            create_account: 'Utwórz konto',
            email_invalid: 'Proszę wpisać poprawny e-mail',
        },
        summary: {
            basic_information: 'Informacje podstawowe',
            transfer_type: 'Typ przejazdu',
            additional_options: 'Dodatkowe opcje',
            contact_data: 'Dane kontaktowe',
            agreements: {
                header: 'Zgody',

                rodo: 'Rodo',
                marketing: 'Marketing',
                data_processing: 'Przetwarzanie danych',
                mailing: 'Wysyłanie mailem',
            },
            order_created:
                'Zamówienie zostało zarejestrowane prawidłowo. Wszystkie informacje zostaną wysłane w wiadomości e-mail.',
            submit: 'Wyślij',
        },
    },

    btm: {
        basic_information: 'Informacje podstawowe',
        one_way: 'W jedną stronę?',
        comment: 'Komentarz',

        date_pick: 'Podaj datę',
        time_pick: 'Podaj godzinę',

        from: 'Wyjazd z',
        to: 'Przyjazd do',

        travel_options: {
            base_options: 'Opcje podstawowe',
            additional_options: 'Opcje dodatkowe',
            header: 'Typ przejazdu',

            plane: {
                is_plane_ticket_needed: 'Potrzebuję biletu lotniczego',
                regular: 'Tradycyjne linie lotnicze',
                low_cost: 'Linie low cost',
                any: 'Dowolne',
            },
            transfer: {
                is_airport_transfer_needed: 'Potrzebuję transfer lotniskowy',
                bt: 'Business Taxi',
                at: 'Airport Shuttle',
                any: 'Dowolny',
            },
            hotel: {
                is_hotel_needed: 'Potrzebuję hotelu',
                stars: 'gwiazdkowy',
                best_price: 'Najlepsza cena',
                best_quality: 'Najlepsza jakość',
            },
            insurance: {
                is_insurance_needed: 'Ubezpieczenie podróży',
            },
            ferry: {
                is_ferry_ticket_needed: 'Potrzebuję biletu na prom',
            },
            train: {
                is_train_ticket_needed: 'Potrzebuję biletu na pociąg',
            },
            coach: {
                is_coach_ticket_needed: 'Potrzebuję biletu na autokar',
            },
            formal_assistance: {
                is_formal_assistance_needed:
                    'Potrzebuję pomocy formalnej (np. wiza)',
            },
            event_assistance: {
                is_event_needed: 'Potrzebuję zorganizować event',
            },
        },

        fields: {
            plane_option: 'Bilet lotniczy',
            transfer_option: 'Transport na lotnisko',
            hotel_stars: 'Standard hotelu (gwiazdki)',
            hotel_preference: 'Preferencja hotelu',
            ferry_start_place: 'Prom Z',
            ferry_end_place: 'Prom Do',
            train_start_place: 'Pociąg Z',
            train_end_place: 'Pociąg Do',
            coach_start_place: 'Autokar Z',
            coach_end_place: 'Autokar Do',
        },

        summary: {
            travel_options: 'Opcje podstawowe i dodatkowe',
            order_created:
                'Zamówienie zostało zarejestrowane prawidłowo. Wszystkie informacje zostaną wysłane w wiadomości e-mail.',
            consents_text: '',
        },
    },

    consents: {
        mark_all: 'Zaznacz wszystkie poniższe',
    },

    validation: {
        iam: {
            user: {
                email_not_unique: 'Podany adres e-mail jest już zajęty',
                login_is_invited: 'Konto jest nieaktywne, aktywuj swoje konto poprzez wpisanie kodu aktywacyjnego z wiadomości e-mail',
                invalid_token_provided: 'Podany kod aktywacyjny jest nieprawidłowy',
                no_pending_invitation: 'Konto jest już aktywne bądź nie zostało zarejestrowane',
                not_found: 'Nie znaleziono użytkownika',
            },
        },
        at_least_one_passenger_required:
            'Musisz wybrać przynajmniej jednego pasażera',
        passwords_have_to_be_same:
            'Pola hasło i potwierdzenie hasła nie są identyczne',
        unable_to_login:
            'Nie można zalogować się na konto, spróbuj ponownie później',
        '4fbb52a8-6945-46b7-b103-a1f4b183082d':
            'Hasło powinno zawierać co najmniej 8 znaków, jedną dużą literę, jedną małą literę, jeden znak specjalny i jedną cyfrę',
        '4b6f5c76-22b4-409d-af16-fbe823ba9332': 'Wartość powinna mieć dokładnie 6 znaków',
        orders: {
            client: {
                business_require_name: 'Pole Nazwa firmy jest wymagane',
                business_require_nip: 'Pole NIP jest wymagane',
            },
            order: {
                invalid_ride_type: 'Nieprawidłowy typ przejazdu',
                ride_type_is_deactivated: 'Typ przejazdu jest dezaktywowany',
                order_requires_min_one_passenger: 'Zamówienie wymaga co najmniej jednego pasażera',
                order_requires_min_one_ride: 'Zamówienie wymaga co najmniej jednego przejazdu',
                cyclic_start_must_be_earlier_than_end: 'Data zakończenia cyklu musi być późniejsza niż data rozpoczęcia',
                no_available_rides_cyclic_found: 'W podanym zakresie dat cyklicznych nie znaleziono dostępnych przejazdów',
                order_cannot_be_created_in_short_time: 'Zbyt krótki czas do odjazdu – rezerwacja możliwa minimum 48 godzin przed rozpoczęciem przejazdu',
                order_requires_only_adult_passengers: 'Zamówienie wymaga tylko dorosłych pasażerów',
                order_requires_only_child_above_4_passengers: 'Zamówienie wymaga tylko dzieci powyżej 4 lat',
                order_requires_ride_character: 'Typ przejazdu wymaga charakterystyki, ale dane nie zostały podane',
                order_ride_stop_point_requires_date: 'Punkt przystankowy wymaga daty',
                order_ride_requires_exactly_two_stops: 'Przejazd wymaga dokładnie dwóch przystanków, ale podano nieprawidłową ilość',
                order_ride_requires_at_least_two_stops: 'Przejazd wymaga co najmniej dwóch przystanków, ale podano nieprawidłową ilość',
                first_or_last_stop_point_must_have_date: 'Pierwszy lub ostatni punkt przystankowy musi mieć datę',
                fmts_stop_points_dates_must_be_at_correct_time: 'Przejazd Follow Me To School ma punkty przystankowe o nieprawidłowej godzinie',
                order_ride_requires_flight_number: 'Przejazd wymaga numeru lotu, ale dane nie zostały podane',
                order_ride_requires_flight_date: 'Przejazd wymaga daty lotu, ale dane nie zostały podane',
                order_ride_requires_vehicle_preferred: 'Przejazd wymaga preferowanego pojazdu, ale dane nie zostały podane',
                order_ride_vehicle_preferred_not_exists: 'Podany preferowany pojazd nie istnieje',
                additional_option_not_exists: 'Podana opcja dodatkowa nie istnieje',
                additional_option_not_active: 'Podana opcja dodatkowa nie jest aktywna',
                voucher_not_exists: 'Podany voucher nie istnieje',
                voucher_is_not_available: 'Podany voucher nie jest dostępny',
                voucher_cannot_be_used: 'Podany voucher nie może być użyty',
                first_passenger_requires_personal_data: 'Dane osobowe pierwszego pasażera nie zostały podane',
            },
            voucher: {
                voucher_not_exists: 'Podany voucher nie istnieje',
                voucher_is_not_available: 'Podany voucher nie jest dostępny',
                voucher_cannot_be_used: 'Podany voucher nie może być użyty',
            },
        },
    },
};
